export default __webpack_public_path__ + "static/media/0000..0002.886f15a2.png";